import {FormControl} from "@angular/forms";

export class SavedSearchesParametersModel {
    public sortOption: string;
    public pageNumber: number;
    public pageSize: number;
}
